import { jsx } from "react/jsx-runtime";
import { ContentType } from "../../../enums/contentStack.js";
import { findOneBusinessEntry, DEFAULT_FIELD_EXCEPTIONS } from "../../../services/content/business.lib.js";
import { getLinkBehavior } from "../../../utils/targetLinkBehavior/getLinkBehavior.js";
import { CategoryTileUI } from "./CategoryTileUI/index.js";
import { INVALID_PROPS_ERROR } from "./constants.js";
const COMPONENT_NAME = "CategoryTile";
const CategoryTile = async (props) => {
  var _a, _b, _c, _d, _e;
  const {
    background,
    foreground,
    entryId,
    locale = "en-us",
    enableLivePreview
  } = props;
  let categoryEntry;
  try {
    categoryEntry = await findOneBusinessEntry(
      ContentType.Category,
      entryId,
      locale,
      DEFAULT_FIELD_EXCEPTIONS,
      enableLivePreview
    );
  } catch {
    console.error(
      `Category Tile error: entry could not be fetched entryId: ${entryId}`
    );
    return null;
  }
  if (!categoryEntry) {
    return null;
  }
  const { external_site, same_tab_domain } = (categoryEntry == null ? void 0 : categoryEntry.category_costco_url) || {};
  const { target } = getLinkBehavior(external_site, same_tab_domain);
  const categoryData = {
    disableThirdPartyTracking: (_a = categoryEntry == null ? void 0 : categoryEntry.privacy_toggle) == null ? void 0 : _a.disable_third_party_tracking,
    hrefUrl: (_b = categoryEntry == null ? void 0 : categoryEntry.category_costco_url) == null ? void 0 : _b.url,
    imageUrl: (_d = (_c = categoryEntry == null ? void 0 : categoryEntry.category_icon) == null ? void 0 : _c[0]) == null ? void 0 : _d.url,
    subTitle: categoryEntry == null ? void 0 : categoryEntry.category_sub_title,
    title: (_e = categoryEntry == null ? void 0 : categoryEntry.category_costco_url) == null ? void 0 : _e.title,
    target
  };
  if (!categoryData.hrefUrl || !categoryData.imageUrl || !foreground && !background) {
    console.error(INVALID_PROPS_ERROR);
    return null;
  }
  return /* @__PURE__ */ jsx(
    CategoryTileUI,
    {
      ...props,
      background,
      categoryData,
      foreground
    }
  );
};
CategoryTile.displayName = COMPONENT_NAME;
export {
  CategoryTile
};
